import _, { isEmpty, reduce } from 'lodash';
import { allowedEmails, ROLES } from 'configs/constants';
import { verifyOtpApi, loginApi } from 'api/auth';

export const getSearch = (filter) => {
  const params = {
    limit: filter?.limit,
    offset: filter?.offset,
    q: filter?.q,
    orderBy: filter?.orderBy,
    ...getValidData(filter?.filter),
  };

  return convertObjToSearchStr(params);
};

export const downloadImg = async ({ url, fileName }) => {
  fetch(url, {
    method: 'GET',
    headers: {},
  })
    .then((response) => {
      response.arrayBuffer().then((buffer) => {
        const url = window.URL.createObjectURL(new Blob([buffer]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName || url);
        document.body.appendChild(link);
        link.click();
      });
    })
    .catch(() => {
      //
    });
};

export const convertObjToSearchStr = (params) =>
  Object.keys(params)
    .map((key) =>
      params[key]
        ? `${encodeURIComponent(key)}=${encodeURIComponent(
          JSON.stringify(params[key]),
        )}`
        : '',
    )
    .filter((data) => data !== '')
    .join('&');

const getValidDataOfObj = (obj, isFilter) => {
  const validData = reduce(
    obj,
    (result, value, key) => {
      if (Array.isArray(value)) {
        return value.length > 0 ? { ...result, [key]: value } : result;
      }
      if (typeof value === 'object' && !isEmpty(value)) {
        const formatChildValue = getValidDataOfObj(value);
        return !isEmpty(formatChildValue)
          ? { ...result, [key]: formatChildValue }
          : result;
      }

      if (value || value === false || value === 0) {
        // eslint-disable-next-line
        result[key] = value;
        return { ...result, [key]: value };
      }

      if (value === '' && !isFilter) {
        // eslint-disable-next-line
        result[key] = '';
      }
      return result;
    },
    {},
  );
  return validData;
};

export const getValidData = (filter, isFilter) =>
  getValidDataOfObj(filter, isFilter);

export const getFilterFromUrl = (searchStr) => {
  const parsed = {};
  if (!searchStr || searchStr.trim() === '') return {};
  decodeURIComponent(searchStr)
    .trim()
    .substring(searchStr?.[0] === '?' ? 1 : 0)
    .split('&')
    .forEach((text) => {
      const keyValue = text.split('=');
      // eslint-disable-next-line
      parsed[keyValue[0]] = keyValue[1];
      try {
        parsed[keyValue[0]] = JSON.parse(parsed[keyValue[0]]);
      } catch (error) {
        // eslint-disable-next-line
        parsed[keyValue[0]] = parsed[keyValue[0]];
      }
    });

  // const parseToObj = zipObjectDeep(Object.keys(parsed), _.values(parsed));

  // delete parsed.limit;
  // delete parsed.offset;
  // delete parsed.order_by;
  // delete parsed.page;
  // delete parsed.q;
  return parsed;
};

export const replaceAll = (str, search, replacement) =>
  str.replace(new RegExp(search, 'g'), replacement);

export const makeBreadCrumbFromPath = (location) => {
  const BREADCRUMB_LIST = [];
  const paths = location.pathname.split('/');
  paths.forEach((data) => {
    if (data === '') return;
    BREADCRUMB_LIST.push({
      title: data,
      path: `${BREADCRUMB_LIST.length
        ? BREADCRUMB_LIST[BREADCRUMB_LIST.length - 1].path
        : ''
        }/${data}`,
    });
  });
  return BREADCRUMB_LIST;
};

export const getImageUrl = (image = '') =>
  (image && (image?.indexOf('http') > -1 || image?.indexOf('https') > -1)) ||
    image?.indexOf('data:image') > -1
    ? image
    : `${process.env.REACT_APP_IMAGE_HOST}${image}`;

export function plainToFlattenObject(object) {
  const result = {};

  function flatten(obj, prefix = '') {
    _.forEach(obj, (value, key) => {
      if (_.isObject(value) || Array.isArray(value)) {
        flatten(value, `${prefix}${key}.`);
      } else {
        result[`${prefix}${key}`] = value;
      }
    });
  }

  flatten(object);

  return result;
}

export function dataURItoBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  let byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
    byteString = atob(dataURI.split(',')[1]);
  else byteString = unescape(dataURI.split(',')[1]);

  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
}

export const downloadImage = (previewImage, fileName = 'product.png') => {
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.href = previewImage;
  a.style = 'display: none';
  a.download = fileName;
  a.click();
  a.remove();
};

export const getPreviewImageUrl = ({
  image = '',
  configs = {},
  ratio,
  width = 400,
}) => {
  const resizeByConvert = {
    bucket: configs?.BUCKET_NAME,
    key: image,
    edits: {
      resize: {
        width,
        fit: 'cover',
      },
    },
  };

  const resizeByRatio = {
    bucket: configs?.BUCKET_NAME,
    key: image,
    edits: {
      resize: {
        ratio,
      },
    },
  };
  const objJsonStr = JSON.stringify(ratio ? resizeByRatio : resizeByConvert);
  const objJsonB64 = btoa(objJsonStr);
  return (image &&
    (image.indexOf('http') > -1 || image.indexOf('https') > -1)) ||
    image.indexOf('data:image') > -1
    ? image
    : `${configs?.CDN_URL}/${objJsonB64}`;
};

export const formatInputMoney = {
  formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
  parser: (value) => value.replace(/\\s?|(,*)/g, ''),
};

export const formatMoney = (number, n = 0, x = 3) => {
  const re = `\\d(?=(\\d{${x}})+${n > 0 ? '\\.' : '$'})`;
  return `${Number(number)
    // eslint-disable-next-line
    .toFixed(Math.max(0, ~~n))
    .replace(new RegExp(re, 'g'), '$&,')} KES`;
};

export const formatNumber = (number = 0, fixed = 2, n, x) => {
  const UNIT = ['', 'K', 'M'];
  let unitRank = 0;
  let tmpPrice = Math.abs(number);
  for (; ;) {
    tmpPrice = Number(tmpPrice) / 1000;
    unitRank += tmpPrice > 1 ? 1 : 0;
    if (tmpPrice < 1) break;
  }
  const re = `\\d(?=(\\d{${x || 3}})+${n > 0 ? '\\.' : '$'})`;
  return `${number >= 0 ? '' : '-'}${Number(tmpPrice * 1000)
    .toFixed(fixed)
    .replace(new RegExp(re, 'g'), '$&,')}${UNIT[unitRank] || ''}`;
};

export const numberWithCommas = (number = 0, fixed = 0) =>
  number
    .toFixed(fixed)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const upperFirstChar = (str) =>
  `${str?.[0]?.toUpperCase() || ''}${str?.substring(1)?.toLowerCase() || ''}`;

export const lowerAllChar = (str) => `${str?.toLowerCase() || ''}`;

export const sumArray = (arr, key) => {
  return arr && arr.length ? arr.reduce((a, b) => a + (b[key] || 0), 0) : 0;
};

export const calculateAge = (dob) => {
  if (!dob) return null;
  const birthDate = parseDate(dob);
  const today = new Date();

  if (isNaN(birthDate)) {
    // throw new Error('Invalid DOB format. Expected DD-MM-YYYY');
    return null;
  }

  if (birthDate > today) {
    // throw new Error('Date of birth cannot be in the future');
    return null;
  }

  // Calculate age in months
  let months = (today.getFullYear() - birthDate.getFullYear()) * 12 +
    (today.getMonth() - birthDate.getMonth());

  // Adjust for day of month
  if (today.getDate() < birthDate.getDate()) {
    months--;
  }

  if (months < 0) {
    // Safety fallback, theoretically should not happen
    // throw new Error('Date of birth cannot be in the future');
    return null;
  }

  if (months <= 3) {
    // throw new Error('Age must be greater than 3 months');
    return null;
  }

  // Return age in years
  return parseFloat((months / 12).toFixed(2));
};

const parseDate = (dobStr) => {
  const [day, month, year] = dobStr.split('-');
  return new Date(`${year}-${month}-${day}`);
};

export const getSearchColumns = () => {
  const role = localStorage.getItem('shofco_role');
  const addresses = JSON.parse(localStorage.getItem('addresses'));
  if (!role || !addresses) {
    localStorage.removeItem('sessionToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('shofco_username');
    localStorage.removeItem('shofco_email');
    localStorage.removeItem('shofco_role');
    localStorage.removeItem('shofco_role_id');
    localStorage.removeItem('addresses');
    localStorage.removeItem('user');
    localStorage.removeItem('userId');
    localStorage.removeItem('appUserId');
    localStorage.removeItem('appUserId');
    localStorage.removeItem('memberId');
    return [];
  }

  return [
    ...((role === ROLES.Data) || (allowedEmails.includes(localStorage.getItem('shofco_email'))) ?
      [

      ] : []
    ),
    ...((role === ROLES.Facilitator) && (!allowedEmails.includes(localStorage.getItem('shofco_email')))
      ? [
        {
          name: 'wardIds',
          value: addresses?.map((a) => a.wardId),
        },
      ]
      : []),
    ...(role === ROLES.CountyCoordinator
      ? [
        {
          name: 'countyId',
          value: addresses.map((a) => a.countyId),
        },
      ]
      : []),
    ...(role === ROLES.RegionalCountyCoordinator
      ? [
        {
          name: 'regionId',
          value: addresses.map((a) => a.regionId),
        },
      ]
      : []),
    ...(role === ROLES.SiteCoordinator
      ? [
        {
          name: 'constituencyId',
          value: addresses.map((a) => a.constituencyId),
        },
      ]
      : []),
  ];
};

export function constructAddress(searchColumns) {
  let address = {};

  searchColumns.forEach(column => {
    if (column.value !== null && column.value !== undefined) {
      address[column.name] = column.value;
    }
  });

  return address;
}

export const getUserAddress = () => {
  const role = localStorage.getItem('shofco_role');
  const addresses = JSON.parse(localStorage.getItem('addresses'));
  if (!role || !addresses) {
    localStorage.removeItem('sessionToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('shofco_username');
    localStorage.removeItem('shofco_email');
    localStorage.removeItem('shofco_role');
    localStorage.removeItem('shofco_role_id');
    localStorage.removeItem('addresses');
    localStorage.removeItem('user');
    localStorage.removeItem('userId');
    localStorage.removeItem('appUserId');
    localStorage.removeItem('appUserId');
    localStorage.removeItem('memberId');
    return [];
  }

  const address = addresses[0];

  return {
    ...(role === ROLES.CountyCoordinator
      ? {
        countyId: address.countyId,
        countyName: address.countyName,
      }
      : role === ROLES.SiteCoordinator ? {
        constituencyId: address.constituencyId,
        constituencyName: address.constituencyName,
      } : role === ROLES.ClusterLeader ? {
        regionId: address.regionId,
        regionName: address.regionName,
      } : role === ROLES.Facilitator ? {
        wardId: address.wardId,
      } :
        {}),
  };
};


// 🎯 Handle confirm session (user chooses to continue)
export const handleConfirmSession = async (navigate, sessionConflictData) => {
  try {
    const resp = await loginApi({
      decisionToken: sessionConflictData.decisionToken
    });

    if (resp?.authToken) {
      // Close modal and complete login
      handleSuccessfulLogin(resp, navigate);
    } else {
      return { success: false, error: resp?.message || 'Failed to confirm session', data: resp };
    }
  } catch (err) {
    return { success: false, error: err?.response?.data?.message || 'Session confirmation failed' };
  }
};

// 🎯 Handle successful login
export const handleSuccessfulLogin = (resp, navigate) => {
  /** 🔐 AUTH */
  localStorage.setItem('sessionToken', resp.authToken);
  localStorage.setItem('refreshToken', resp.refreshToken);

  /** 👤 USER INFO */
  localStorage.setItem('userId', resp?.userInfo?.id);
  localStorage.setItem('loginId', resp?.userInfo?.loginId);
  localStorage.setItem('shofco_email', resp?.userInfo?.email);
  localStorage.setItem('shofco_role', resp?.userInfo?.role);
  localStorage.setItem('shofco_role_id', String(resp?.userInfo?.roleId));
  localStorage.setItem('sname', resp?.userInfo?.fullName);
  localStorage.setItem(
    'shofco_username',
    resp?.userInfo?.firstName || resp?.userInfo?.email
  );

  localStorage.setItem(
    'addresses',
    JSON.stringify(resp?.userInfo?.addresses || [])
  );

  // Clear MFA session
  sessionStorage.removeItem('mfaToken');
  sessionStorage.removeItem('loginId');

  navigate('/dashboard', { replace: true });
  // window.location.reload();
};

// 🎯 Handle cancel (user doesn't want to logout others)
export const handleCancelSession = (navigate) => {
  // Optionally redirect to login

};

// 🎯 Format time ago for display
export const formatTimeAgo = (timestamp) => {
  if (!timestamp) return 'Unknown';
  const date = new Date(timestamp);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} minutes ago`;

  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours} hours ago`;

  return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
};

// 🎯 Format channel name
export const formatChannel = (channel) => {
  const channelMap = {
    'WEB': 'Web Browser',
    'APP': 'Mobile App',
    'USSD': 'USSD'
  };
  return channelMap[channel] || channel;
};
